import { getSanitizedAction, type DeeplinkAction } from '@/lib/navigation-allowlist';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

export { getSanitizedAction, type DeeplinkAction } from '@/lib/navigation-allowlist';

/** Returns validated `action` query param or null. */
export const useDeeplinkAction = (): DeeplinkAction | null => {
  const router = useRouter();

  return useMemo(() => getSanitizedAction(router.query.action), [router.query.action]);
};
